/**
 * 日付フォーマット
 */
// 年月日(WEB API向け)
export const API_DAY_FORMAT = 'YYYY-MM-DD'
// 年月日 時分秒(WEB API向け)
export const API_DAYTIME_FORMAT = 'YYYY-MM-DD HH:mm:00'
// 年月日(画面表示)
export const DISPLAY_DAY_FORMAT = 'YYYY-MM-DD'
// 年月日 時分秒(画面表示)
export const DISPLAY_DAYTIME_FORMAT = 'YYYY-MM-DD HH:mm:SS'
